import { CategoryEntity } from '../entities';
import { BusinessUnitRepository } from '../ports/repositories';

export class FindBusinessUnitCategoryUseCase {
  constructor(private readonly repo: BusinessUnitRepository) {}

  async run(): Promise<CategoryEntity[]> {
    return this.repo.findCategory();
  }
}
